<template>
  <section>
    <b-field label="Username" :type="{ 'is-danger': hasError }">
      <b-input v-model="name" maxlength="30"></b-input>
    </b-field>

    <b-field label="Password" :type="{ 'is-danger': hasError }">
      <b-input v-model="password" type="password" maxlength="30"></b-input>
    </b-field>
    <button @click="submit" class="button is-primary">go go</button>
  </section>
</template>

<script>
import {mapActions} from 'vuex'
import { setTimeout } from 'timers';
export default {
  data() {
    return {
      hasError: false,
      name: '',
      password: ''
    };
  },
  methods: {
      ...mapActions(['getAuth']),
      submit() {
          this.getAuth({e: this.name, p: this.password}).then(() => {
            this.$router.push('/')
          }).catch(() => {
            this.setError()
          });
      },
      setError() {
          this.hasError = true
          setTimeout(() => {
            this.hasError = false
          }, 3000)
      }
  }
};
</script>

<style lang="scss" scoped>
section {
  max-width: 500px;
  margin: 0 auto;
  margin-top: 15vh;
}
</style>

